import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute -top-6 z-10 overflow-hidden h-6 w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-6 w-full transform rotate-180 shadow-lg shadow-neutral-800/20 p-2" })
], -1)
const _hoisted_3 = { class: "w-full min-h-12 flex justify-between items-center bg-neutral-200 z-20" }
const _hoisted_4 = { class: "w-full p-2 text-neutral-600 text-xs z-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReplyHome = _resolveComponent("ReplyHome")!

  return (_ctx.messageReply)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ReplyHome, {
              modelValue: _ctx.messageReply,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.messageReply) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("a", {
            title: "Cancelar resposta!",
            href: "#",
            class: _normalizeClass([
                    'py-2 px-4 rounded-full cursor-pointer text-xl text-neutral-700',
                    'webchat-transition opacity-50 hover:opacity-100'
                ]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)), ["stop","prevent"]))
          }, " × ")
        ])
      ]))
    : _createCommentVNode("", true)
}